import * as React from 'react';
import { observer } from 'mobx-react';
import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';

import { SmartShoppingNoApiResponse } from '../../components/shared/error-messages';
import { Viewport, ViewSmall, ViewLarge } from '@shared-ui/viewport-context';
import { UniversalSortTabs } from './universal-sort-tabs';
import { useStores } from 'utility/hooks';
import { SmartListings } from 'experiments/Air_Smart_Shopping_44809';

export const ListingsWrapper = observer(() => {
  const { listingsStore } = useStores();
  const shouldRenderNoApiResponse = listingsStore.smartShoppingNoResponse && !listingsStore.smartShoppingLoading;
  const shouldRenderSortTabs = listingsStore.smartShoppingShowFlexAndFilters;

  return (
    <>
      {shouldRenderNoApiResponse ? (
        <SmartShoppingNoApiResponse />
      ) : (
        <>
          {shouldRenderSortTabs && (
            <UitkCard>
              <UitkCardContentSection padded={false}>
                <UniversalSortTabs />
              </UitkCardContentSection>
            </UitkCard>
          )}
          <Viewport>
            <ViewLarge>
              <SmartListings />
            </ViewLarge>
            <ViewSmall>
              <SmartListings isSmallViewPort />
            </ViewSmall>
          </Viewport>
        </>
      )}
    </>
  );
});
